<div class="emd-container">
    <section class="form-section">
        <div class="emd-container__header section-header" style="min-height: 0em; padding: 0.25rem">
            <h2 class="emd-text _type_caption" style="font-size: 1rem">{{ title }}</h2>

            <button
                class="emd-btn _type_text slide-button"
                (click)="handleCollapse()"
                [disabled]="isDisabled"
            >
                <i *ngIf="!isActive" class="fa fa-chevron-down" aria-hidden="true"></i>
                <i *ngIf="isActive" class="fa fa-chevron-up" aria-hidden="true"></i>
            </button>
        </div>
        <div class="form-section-body" *ngIf="isActive">
            <ng-content></ng-content>
        </div>
    </section>
</div>
